import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { CuiNavigationButton } from './NavigationButton';

export const CuiNavigation = ({ className, routes, ...rest }) => {
  const cuiNavItems = [];

  let groupIndex = 1;

  for (let i = 0; i < routes.length; i += 1) {
    const route = routes[i];
    switch (route.type) {
      case 'section':
        cuiNavItems.push(
          <CuiNavigationButton
            type="section"
            path={route.path}
            key={route.path}
          >
            {route.name}
          </CuiNavigationButton>
        );
        break;

      case 'group':
        cuiNavItems.push(
          <CuiNavigationButton
            type="group"
            path={route.path}
            key={route.path}
            index={groupIndex}
          >
            {route.name}
          </CuiNavigationButton>
        );
        groupIndex += 1;
        break;

      case 'page':
        cuiNavItems.push(
          <CuiNavigationButton path={route.path} key={route.path}>
            {route.name}
          </CuiNavigationButton>
        );
        break;

      default:
        break;
    }
  }

  const classes = classNames('cuiNavigation', className);

  return (
    <nav className={classes} {...rest}>
      {cuiNavItems}
    </nav>
  );
};

CuiNavigation.propTypes = {
  className: PropTypes.string,
  routes: PropTypes.array,
};

CuiNavigation.defaultProps = {
  className: undefined,
  routes: [],
};



// WEBPACK FOOTER //
// ./ui/components/sideBar/navigation/Navigation.js